import { TweenMax, TimelineMax, Power2, Back } from "gsap";

export default class Intro {
    constructor() {
        this._init();
    }

    start(callback = null) {
        this.callback = callback;

        if (window.innerWidth <= 768) {
            this._initAnime();
            this._setAnime();
        }
    }

    _init() {
        this.$main = document.querySelector(".c-main");
        this.$page_title = document.querySelector(".pageHeader__title-sp");
        this.$recommend = document.querySelector(".pageHeader__recommend-sp");
        this.$recommend_title = document.querySelector(".pageHeader__recommend-sp__title");
        this.$recommend_book = document.querySelector(".pageHeader__recommend-sp__book img");
        this.branches = document.querySelectorAll(".branches");
    }

    _initAnime() {
        TweenMax.set(this.$page_title, { opacity: 0, rotation: 40, xPercent: 30 });
        TweenMax.set(this.$recommend, { opacity: 0, rotation: 40, xPercent: 30 });
        TweenMax.set(this.$recommend_title, { opacity: 0, rotation: -20 });
        TweenMax.set(this.$recommend_book, { opacity: 0, scale: 0.5 });
        TweenMax.set(this.branches, { opacity: 0, top: 20 });
    }

    _setAnime() {
        const tl = new TimelineMax();
        tl.call(this._showMain.bind(this), null, null, 0.5).call(this._showHeader.bind(this), null, null, 0.75).call(this._showHBranch.bind(this), null, null, 1);
        TweenMax.set(this.$main, { opacity: 0, visibility: "visible" });
    }

    _showMain() {
        TweenMax.to(this.$main, 0.5, { opacity: 1, ease: Power2.out });
    }

    _showHeader() {
        TweenMax.to(this.$page_title, 0.8, { opacity: 1, rotation: 0, xPercent: 0, ease: Back.easeOut.config(1.7) });
        TweenMax.to(this.$recommend, 0.8, { delay: 0.1, opacity: 1, rotation: 0, xPercent: 0, ease: Back.easeOut.config(1.7) });
        TweenMax.to(this.$recommend_title, 0.35, { delay: 1.0, opacity: 1, rotation: 0, ease: Back.easeOut.config(1.7) });
        TweenMax.to(this.$recommend_book, 0.35, { delay: 1.1, opacity: 1, scale: 1, ease: Power2.out });
    }

    _showHBranch() {
        TweenMax.to(this.branches, 0.7, { opacity: 1, top: 0, ease: Power2.out });
        if (this.callback) this.callback();
    }
}
